import React, { useEffect, useState, useContext, useCallback } from "react";
import {
  useForm,
  FormProvider,
  useFormContext,
  useWatch,
} from "react-hook-form";
import moment from "moment";
//Function
import { getReportSourceBI } from "../api";
import { ApiDateTimeFormat, ToDateText } from "../../../utils/date";
//Material Ui
import Box from "@material-ui/core/Box";
import { Typography } from "@material-ui/core";
import LinearProgress from "@material-ui/core/LinearProgress";
//Component
import { BaseContainer } from "./../../../stories/base-container";
import Criteria from "../criteria";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import ReportTable from "./../table";
//Context
import {
  LoadingContext,
  withLoadingContext,
} from "../../../context/loading-context";
const columnsOFM = [
  { id: "CDR_TYPE", label: "CDR Type", minWidth: 170, align: "left" },
  {
    id: "DTN_OFM",
    label: "OFM",
    minWidth: 170,
    align: "right",
    dataAlign: "right",
  },
  {
    id: "DTN_BI",
    label: "OFM",
    minWidth: 170,
    align: "right",
    dataAlign: "right",
  },
  {
    id: "DTN_DIFF",
    label: "OFM",
    minWidth: 170,
    align: "right",
    dataAlign: "right",
  },
];
const columnsDom = [
  {
    id: "CDR_TYPE",
    label: "CDR Type",
    width: 170,
    align: "center",
    dataAlign: "left",
  },
  { id: "MD", label: "MD", width: 170, align: "center", dataAlign: "right" },
  { id: "BI", label: "BI", width: 170, align: "center", dataAlign: "right" },
  {
    id: "DIF",
    label: "DIF",
    width: 170,
    align: "center",
    dataAlign: "right",
  },
];
const customheaderOFM = (color) => {
  return (
    <TableHead>
      <TableRow>
        <TableCell rowSpan={2} align="center">
          CDR Type
        </TableCell>
        <TableCell colSpan={4} align="center">
          DTN
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell align="center">OFM</TableCell>
        <TableCell align="center">BI</TableCell>
        <TableCell align="center" style={{ backgroundColor: color }}>
          Different
        </TableCell>
      </TableRow>
    </TableHead>
  );
};
function SourceBI() {
  const methods = useForm({
    defaultValues: { date: moment().format(ApiDateTimeFormat) },
  });
  const Loading_context = useContext(LoadingContext);
  const { actions: load_actions } = Loading_context;
  const [OFM_lst, setOFM_lst] = useState([]);
  const [Dom_lst, setDom_lst] = useState([]);
  const [date, setDate] = useState();
  const { getValues } = methods;
  const query = useCallback(async () => {
    let param = getValues();
    let dat = await load_actions.withLoading(() => getReportSourceBI(param));
    if (!dat) return;
    setOFM_lst(dat?.OFM?.Rows);
    setDom_lst(dat?.Domestic_Roaming?.Rows);
    setDate(ToDateText(dat?.Date));
  }, [load_actions, getValues]);
  useEffect(() => {
    query();
  }, [query]);
  //changeColor(columnsDom, "DIF", Dom_lst[0]?.DIFF_COLOR_CODE);
  return (
    <FormProvider {...methods}>
      <BaseContainer>
        {Loading_context.state?.isLoading ? (
          <div className="lineLoading">
            <LinearProgress />
          </div>
        ) : null}
        <Box display="flex" justifyContent="center">
          <Typography variant="h4">source-bi report</Typography>
        </Box>
        <Criteria query={query} />
        <Box display="flex" justifyContent="center">{`Date :${
          date || ""
        }`}</Box>
        <ReportTable
          data={OFM_lst}
          columns={columnsOFM}
          header={customheaderOFM}
          cellColor={[{ fieldId: "DTN_DIFF", fieldColor: "DIFF_COLOR_CODE" }]}
        />
        <Box m={2}></Box>
        <ReportTable
          title="Domestic Roaming"
          width="800px"
          data={Dom_lst}
          columns={columnsDom}
          cellColor={[{ fieldId: "DIF", fieldColor: "DIFF_COLOR_CODE" }]}
        />
      </BaseContainer>
    </FormProvider>
  );
}
function changeColor(arr, col, color) {
  for (var i in arr) {
    if (arr[i].id === col) {
      arr[i].backgroundColor = color;
      break; //Stop this loop, we found it!
    }
  }
  return arr;
}

export default withLoadingContext(SourceBI);
